// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l4ld18yRybZ4q2 {
  display: block;
  position: relative;
  width: 400px;
  overflow: hidden;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-400, 16px);
  opacity: 1;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  -webkit-backdrop-filter: blur(0);
          backdrop-filter: blur(0);
}
.l4ld18yRybZ4q2.uJ1lxJkNoO6W5c {
  margin-right: var(--ds-space-150, 12px);
  background-color: unset;
}
.l4ld18yRybZ4q2.Vs24AzArsFt_vo {
  border: none;
}
.l4ld18yRybZ4q2.kYK1L99KiPxY9f {
  transition: flex 0.2s ease-in-out, opacity 0.2s ease-in, border-radius 0.2s ease-in-out, margin 0.2s ease-in-out, padding 0.2s ease-in-out;
}
@media (prefers-reduced-motion) {
  .l4ld18yRybZ4q2.kYK1L99KiPxY9f {
    transition: unset;
  }
}
.l4ld18yRybZ4q2:not(.EtTuY3mikhofX0):not(.ACJOnLzDdzqpf5):not(.e44PC2Xlt4VODs):first-of-type {
  margin-left: var(--ds-space-075, 6px);
}
.l4ld18yRybZ4q2:not(.EtTuY3mikhofX0):not(.ACJOnLzDdzqpf5):not(.e44PC2Xlt4VODs):last-of-type {
  margin-right: var(--ds-space-075, 6px);
}
.l4ld18yRybZ4q2.ACJOnLzDdzqpf5 {
  flex-grow: 1;
  margin: var(--ds-space-0, 0);
  border: unset;
  border-radius: 0;
}
.l4ld18yRybZ4q2.e44PC2Xlt4VODs {
  width: 0px;
  margin: var(--ds-space-0, 0);
  opacity: 0;
}
@media print {
  .l4ld18yRybZ4q2 {
    width: 100%;
    overflow: visible;
  }
}
`, ""]);
// Exports
export var panel = `l4ld18yRybZ4q2`;
export var boardSwitcherPanel = `uJ1lxJkNoO6W5c`;
export var collapsed = `Vs24AzArsFt_vo`;
export var panelTransitions = `kYK1L99KiPxY9f`;
export var noDividers = `EtTuY3mikhofX0`;
export var singlePanel = `ACJOnLzDdzqpf5`;
export var hidden = `e44PC2Xlt4VODs`;
export default ___CSS_LOADER_EXPORT___;
